import './TopbarPageTemplate.scss';
import { ReactNode } from 'react';
import { IChildrenProp, IDiv } from 'types/components/components.interface';

interface ITopbarPageTemplateProps extends IChildrenProp, IDiv {
  topbar: ReactNode;
}

const TopbarPageTemplate = ({
  children,
  topbar,
  className = '',
  ...props
}: ITopbarPageTemplateProps) => {
  return (
    <div style={props.style} className='topbar-tabs-template'>
      <div className='topbar'>{topbar}</div>
      <div {...props} style={{}} className={`tab-content ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default TopbarPageTemplate;
